 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		9: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"4":"vendors~dashboard1~dashboard15~dashboard2","5":"dashboard1~dashboard2","6":"adminRoles","7":"adminUser","8":"bannerSettings","10":"commonSettings","11":"contentPage","12":"contentPagePreview","13":"dashboard","14":"dashboard1","15":"dashboard10","16":"dashboard11","17":"dashboard12","18":"dashboard13","19":"dashboard14","20":"dashboard15","21":"dashboard16","22":"dashboard17","23":"dashboard18","24":"dashboard19","25":"dashboard2","26":"dashboard20","27":"dashboard21","28":"dashboard22","29":"dashboard23","30":"dashboard24","31":"dashboard25","32":"dashboard26","33":"dashboard27","34":"dashboard28","35":"dashboard29","36":"dashboard3","37":"dashboard30","38":"dashboard31","39":"dashboard32","40":"dashboard33","41":"dashboard34","42":"dashboard35","43":"dashboard36","44":"dashboard37","45":"dashboard39","46":"dashboard4","47":"dashboard5","48":"dashboard6","49":"dashboard7","50":"dashboard8","51":"dashboard9","52":"editRestaurant","53":"home","54":"infoSettings","55":"legal","56":"login","57":"manageServiceFee","58":"manualPayout","59":"not-found","60":"polyfills","61":"pricing","62":"restaurant","63":"restaurant-addfooditem","64":"restaurant-menu","65":"restaurant-menu-add","66":"restaurant-modifiergroups","67":"restaurant-operation-hours","68":"restaurant-password","69":"restaurant-preparation-time","70":"restaurant-receipt-details","71":"restaurant-signup","72":"restaurantsList","73":"sliderSettings","74":"static","75":"vehicleType","77":"vendors~dashboard","78":"vendors~polyfills"}[chunkId]||chunkId) + "." + {"0":"2bacb3d8","1":"e4eba9e5","2":"905b40c4","3":"38d8dc7d","4":"eba1aa22","5":"ad33dcc3","6":"7810ba28","7":"9d829ddd","8":"542e7ed4","10":"1152bce8","11":"ba60983e","12":"a811c2e6","13":"dccde909","14":"21766f7e","15":"077fec1c","16":"59044e91","17":"db9e0c17","18":"b13128d6","19":"abda9933","20":"f3420a14","21":"63a8342d","22":"159bd3b0","23":"b195169e","24":"30b726e5","25":"de82ee29","26":"be16a770","27":"b64dcbe9","28":"7a7a1fac","29":"f2ab9561","30":"f9d4484d","31":"9cde229f","32":"1455e99f","33":"0ac079c4","34":"0949941b","35":"8dd174f7","36":"dc67bded","37":"3514446a","38":"2017854f","39":"7cdc41bf","40":"0562f678","41":"5042b8f9","42":"7f6084ea","43":"191502ef","44":"7febbb47","45":"f74b695b","46":"2b152605","47":"3d8bef0c","48":"cdd60480","49":"ebc7b005","50":"c3b0dcd1","51":"e6c74886","52":"21f4b507","53":"f3877d60","54":"1bdf268c","55":"1a5cbbf2","56":"f9cd7a92","57":"a14e8747","58":"120b713f","59":"766cdd08","60":"265b7279","61":"64f373f5","62":"4a065cd5","63":"c9cdb2f7","64":"0c12644c","65":"843e1d6f","66":"22cb3507","67":"ef31870f","68":"093b2619","69":"b92c7c2e","70":"83c17110","71":"3beb1eca","72":"688ed06d","73":"c5138a9b","74":"60fde95d","75":"4a5a8f4a","77":"a9846045","78":"807cd45c","79":"baa5f95a"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([407,76]);
 	// run deferred modules when ready
 	return checkDeferredModules();
